import { ADD_TO_CART_DETAILS } from './types';


export const includeQuickViewAddToCartDetailsAction = (productDetails) => dispatch => {
    console.log('product inside addToListDetailsAction...', productDetails);
    dispatch({
        type: ADD_TO_CART_DETAILS,
        addedProductDetails : productDetails
   
    })
}
